/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlayslipMessageGroup } from './PlayslipMessageGroup';
import {
    PlayslipMessageGroupFromJSON,
    PlayslipMessageGroupFromJSONTyped,
    PlayslipMessageGroupToJSON,
} from './PlayslipMessageGroup';

/**
 * One piece of playslip copy a customer may reword.
 * @export
 * @interface PlayslipMessageCatalogEntry
 */
export interface PlayslipMessageCatalogEntry {
    /**
     * Where the text appears, when the key alone does not say.
     * @type {string}
     * @memberof PlayslipMessageCatalogEntry
     */
    description?: string;
    /**
     * What players see when the theme leaves this key out. Words in braces, like {count}, are filled in by the app.
     * @type {string}
     * @memberof PlayslipMessageCatalogEntry
     */
    defaultText: string;
    /**
     * 
     * @type {PlayslipMessageGroup}
     * @memberof PlayslipMessageCatalogEntry
     */
    group: PlayslipMessageGroup;
    /**
     * The key a theme's messages are stored under.
     * @type {string}
     * @memberof PlayslipMessageCatalogEntry
     */
    key: string;
}



/**
 * Check if a given object implements the PlayslipMessageCatalogEntry interface.
 */
export function instanceOfPlayslipMessageCatalogEntry(value: object): value is PlayslipMessageCatalogEntry {
    if (!('defaultText' in value) || value['defaultText'] === undefined) return false;
    if (!('group' in value) || value['group'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function PlayslipMessageCatalogEntryFromJSON(json: any): PlayslipMessageCatalogEntry {
    return PlayslipMessageCatalogEntryFromJSONTyped(json, false);
}

export function PlayslipMessageCatalogEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayslipMessageCatalogEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'defaultText': json['defaultText'],
        'group': PlayslipMessageGroupFromJSON(json['group']),
        'key': json['key'],
    };
}

export function PlayslipMessageCatalogEntryToJSON(value?: PlayslipMessageCatalogEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'defaultText': value['defaultText'],
        'group': PlayslipMessageGroupToJSON(value['group']),
        'key': value['key'],
    };
}

